import type { AllCategories } from '@cc-shopping/contracts/compare/schema/types';
import type { CardOfferButtonWithAnalytics } from '../HorizontalScrollableCardList';
import type { CategoryToOffersMetadata } from '.';

export const COMPARE_FILTERS_CATEGORY_DISPLAY_LIST = [
  'Best Offers',
  'Previously Viewed',
  'Travel',
  'Balance Transfer',
  '0% Intro APR',
  'Cash Back',
  'Rewards',
];

export enum CompareSectionNames {
  best_offers = 'best_offers',
  previously_viewed = 'previously_viewed',
  travel = 'travel',
  balance_transfer = 'balance_transfer',
  low_interest = 'low_interest',
  cash_back = 'cash_back',
  rewards = 'rewards',
}

export const COMPARE_DISPLAY_NAME_TO_SECTION_NAME: Record<string, CompareSectionNames> = {
  'Best Offers': CompareSectionNames.best_offers,
  'Previously Viewed': CompareSectionNames.previously_viewed,
  Travel: CompareSectionNames.travel,
  'Balance Transfer': CompareSectionNames.balance_transfer,
  '0% Intro APR': CompareSectionNames.low_interest,
  'Cash Back': CompareSectionNames.cash_back,
  Rewards: CompareSectionNames.rewards,
};

const COMPARE_FILTERS_CATEGORY_KEY_LIST: (AllCategories | 'previously-viewed')[] = [
  'the-best-credit-cards',
  'previously-viewed',
  'travel-miles-credit-cards',
  'balance-transfer-credit-cards',
  'zero-percent-credit-cards',
  'cash-rewards-credit-cards',
  'rewards-credit-cards',
];

export const compareQuickFiltersOnSelectTab = (
  index: number,
  categoryToCardOfferButtons: CategoryToOffersMetadata,
  setDisplayedCardOfferButtons: (cardOfferButtons: CardOfferButtonWithAnalytics[]) => void,
) => {
  let filteredCardOfferButtons: CardOfferButtonWithAnalytics[] = [];
  const categoryName: string = COMPARE_FILTERS_CATEGORY_KEY_LIST[index];
  filteredCardOfferButtons = categoryToCardOfferButtons[categoryName];
  setDisplayedCardOfferButtons(filteredCardOfferButtons);
};
